import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseEditIcon = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 684 687"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M612.955 4.02975C599.189 10.2641 337.209 276.558 329.661 291.698C316.784 318.417 299.022 379.424 303.019 383.432C305.239 385.658 326.552 380.76 355.415 371.408L404.258 354.932L684 76.1696V53.9042C684 34.756 681.78 29.4123 670.235 17.389C655.582 2.69382 629.384 -3.09517 612.955 4.02975Z" />
        <path d="M54.7431 89.4771C30.8584 99.963 6.3912 129.673 2.31333 152.975C0.56567 163.461 -0.599435 274.146 0.56567 399.978C2.31333 619.6 2.89588 628.921 14.5469 644.067C20.955 652.805 33.7712 665.622 42.5095 672.03C57.6558 683.681 66.9767 684.263 289.512 686.011C442.141 687.176 527.776 686.011 542.34 681.35C567.972 673.777 597.682 641.737 602.343 616.105C604.09 605.619 605.255 533.382 604.09 455.32L602.343 313.76L512.047 397.065V593.968H92.609V174.53H288.347L314.562 146.567C328.543 131.421 347.767 110.449 357.67 99.963L374.564 81.3213H223.101C110.668 81.9039 67.5592 83.6515 54.7431 89.4771Z" />
    </svg>
);

export const EditIcon = styled(BaseEditIcon)``;
